export default "__VITE_ASSET__CxYhitxf__"